module.exports = __webpack_public_path__ + "static/media/blog3.c6c77bdd.png";